// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/ui/botao-fake.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/ui/botao-nao-fake.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
html, body, #root { height: 100%; }
body { margin: 0; background: #000; }

:root {
--jedi-violet: #6929fc;
--jedi-blue: #5cc6d0;
--jedi-green:  #c4de1d;
--jedi-pink: #ec62ff;
--jedi-dark-green: #647e0d;
--jedi-background: #3f219b;
--jedi-main-title: #bfe9ec;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.game-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgb(0, 0, 128);
  overflow: hidden;
  /* Permitir que o container seja escalado */
  transform-origin: center center;
}

/* Camada isolada para UI (painéis, botões) - melhora composição */
.ui-layer {
  position: absolute;
  inset: 0;
  z-index: 20000;
  pointer-events: none;
}

.ui-layer > * {
  pointer-events: auto;
}

.game-exit-button {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 2000;
  border: 1px solid rgba(196, 222, 29, 0.65);
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.55);
  color: var(--jedi-green);
  font-size: 0.9rem;
  font-weight: 700;
  padding: 8px 14px;
  cursor: pointer;
}

.board-container {
  position: absolute;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  top: 0;
  left: 0;
}

.game-info {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 15px;
  border-radius: 10px;
  z-index: 100;
  font-weight: bold;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);
}

.debug-overlay {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px 15px;
  border-radius: 8px;
  z-index: 100;
  font-family: monospace;
  font-size: 14px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

/* Estilos para visualização de debug do jogador */
.debug-grid-cell {
  position: absolute;
  width: 64px;
  height: 32px;
  border: 1px dashed rgba(255, 255, 255, 0.5);
  transform: rotateX(60deg) rotateZ(-45deg);
  transform-style: preserve-3d;
  pointer-events: none;
}

/* Garantir que elementos 3D sejam renderizados corretamente */
* {
  transform-style: preserve-3d;
  backface-visibility: hidden;
}

/* Classes para animações */
.shake {
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}

.fade-in {
  animation: fadeIn 0.5s ease-in;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

/* Estilos para transformações 3D */
.isometric-board, .tile, .player, .dice, .dice-face {
  transform-style: preserve-3d;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
}

.news-board {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 50%;
  height: auto;
  z-index: 7000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  will-change: transform, opacity;
  transform: translateZ(0) translateX(-50%);
}

.news-board-content-image {
  position: relative;
  width: 60dvw;
  height: 30dvh;
  margin: 0 50px;
  z-index: 7001;
  border-radius: 30px;
  border: 5px solid rgba(255, 255, 255, 0.1);
  pointer-events: auto;
  opacity: 1;
  overflow: hidden;
  will-change: transform, opacity;
  transform: translateZ(0);
}

/* Painel estilo aeroporto */
.airport-panel {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 25px;
  overflow-y: auto; 
  z-index: 6000;

  
  /* Se precisar de efeito 3D nas bordas manipular as cores das bordas * /
  border: 9px solid #bbb;
  /* Efeito de degradê #007 #00F #007 simulando um cano iluminado * /
  border-top-color: linear-gradient(to bottom, #007, #00F, #007);
  border-left-color: linear-gradient(to right, #007, #00F, #007);
  border-right-color: linear-gradient(to left, #007, #00F, #007);
  border-bottom-color: linear-gradient(to bottom, #007, #00F, #007);
  
  /* Sombra interna para efeito de profundidade * /
  box-shadow: 
    inset 2px 2px 4px rgba(255, 255, 255, 0.8),
    inset -2px -2px 4px rgba(0, 0, 0, 0.2);
*/

opacity: 1;
border-radius: 25px; /* Metade da altura para um formato roliço */
box-sizing: border-box; /* Garante que padding e border não aumentem o tamanho total */
position: relative; /* Pode ser útil para pseudo-elementos ou posicionamento */
overflow: hidden; /* Garante que o gradiente de fundo não vaze */

/* Fundo do cano com gradiente radial para volume */
/* old-background: radial-gradient(circle at 50% 50%, #44AADD 0%, #0077BB 70%, #004488 100%); */
background: radial-gradient(
  circle at 50% 50%,
  rgba(68, 170, 221, 0.35) 0%,
  rgba(0, 119, 187, 0.4) 70%,
  rgba(0, 68, 136, 0.45) 100%
);

/* Borda com gradiente para simular reflexo/iluminação na borda */
border: 4px solid transparent; /* Largura da borda que o border-image vai preencher */
border-image: linear-gradient(to right, #0077BB, #44AADD, #0077BB) 1;
/* O '1' é para border-image-slice, estendendo o gradiente por toda a borda */

/* Múltiplas sombras para profundidade, brilho e efeito roliço */
box-shadow:
  /* Sombra interna para luz no topo e sombra na base (efeito 3D roliço) */
  inset 0 2px 5px rgba(255, 255, 255, 0.4), /* Luz no topo (quase branco) */
  inset 0 -2px 5px rgba(0, 0, 0, 0.3),   /* Sombra na parte inferior (quase preto) */

  /* Brilho externo sutil (iluminação geral) */
  0 0 10px rgba(68, 173, 221, 0.6), /* Brilho azul mais forte */
  0 0 20px rgba(68, 173, 221, 0.3); /* Brilho azul mais suave e espalhado */


}

.airport-panel-content {
  flex: 1 1;
  padding: 20px;
/*  background: linear-gradient(to bottom, var(--jedi-green), var(--jedi-dark-green)); */
  background: linear-gradient(to bottom, #777777, #444444); /* white degrades to light gray */
  border-radius: 22px 22px 0 0;
  
  /* Efeito de tela LCD */
  position: relative;

  height: auto;
  
  /* Layout flexível para as seções de explicação */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.airport-panel-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 2px,
      rgba(0, 0, 0, 0.03) 2px,
      rgba(0, 0, 0, 0.03) 4px
    );
  pointer-events: none;
  border-radius: 22px 22px 0 0;
}

.airport-panel-content--news {
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
  background: linear-gradient(
    to bottom,
    rgba(119, 119, 119, 0.65),
    rgba(68, 68, 68, 0.68)
  );
}

/* Faixa azul escura na parte inferior */
.airport-panel-footer {  
  background: linear-gradient(to bottom, #3f51b5, var(--jedi-violet));
  position: relative;
  overflow: hidden;
  border-radius: 0 0 22px 22px;
  
  top: auto;
  bottom: 0px;
  height: 6dvh;
  
  /* Efeito 3D na faixa */
  border-top: 2px solid #3f51b5;
  box-shadow: 
    inset 0 2px 4px rgba(255, 255, 255, 0.3),
    inset 0 -2px 4px rgba(0, 0, 0, 0.3);
}

/* Texto rolante */
.rolling-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
  color: white; /* add shadows to the text */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-family: 'Courier New', monospace;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  
  /* Animação de rolagem */
  animation: scrollText 120s linear infinite;
}
@media screen and (max-width: 768px) {
  .airport-panel-footer {
    height: 12px;
  }
  .rolling-text {
    font-size: 14px;
  }
}
@media screen and (max-width: 480px) {
  .airport-panel-footer {
    height: 10%;
  }
  .rolling-text {
    font-size: 16px;
  }
}

.rolling-text span {
  margin-right: 100px;
}

@keyframes scrollText {
  0% {
    transform: translateY(-50%) translateX(90%);
  }
  100% {
    transform: translateY(-50%) translateX(-90%);
  }
}

.news-board-content-text {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: bold;
  text-align: justify;
  display: grid;
  place-items: safe center;
  font-size: 20px;
  line-height: 1.25;
  overflow-x: hidden;
  overflow-y: auto;
  overflow-wrap: anywhere;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  -webkit-overflow-scrolling: touch;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  z-index: 1;
  pointer-events: auto;
  padding: 0px 5px;
}

.news-board-content-text-inner {
  display: block;
  width: 100%;
}
@media screen and (max-width: 1024px) {
  .news-board-content-text {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .news-board-content-text {
    font-size: 10px;
  }
}

/* Deve estar escrito sobre o  botão o texto "FAKE" */
.button-container .button-fake::before {
  content: 'Fake';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: blue;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  margin: 0;
}
@media screen and (max-width: 768px) {
  .button-container .button-fake::before {
    font-size: 10px;
  }
}
@media screen and (max-width: 480px) {
  .button-container .button-fake::before {
    font-size: 8px;
  }
}

.button-container .button-fake {
  opacity: 1.0;
  pointer-events: auto; 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  margin-right: 10px;
  margin-top: 0px;
  will-change: transform, opacity;
  transform: translateZ(0);
  cursor: pointer !important;
  transition: transform 0.3s ease;
  transform: scale(1); 
  position: relative;
  z-index: 3000;
}

.button-container .button-fake:hover {
  transform: scale(1.05);
}

.button-container .button-not-fake::before {
  content: 'Não Fake';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: blue;
  font-family: 'Arial', sans-serif;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  margin: 0;
}
@media screen and (max-width: 768px) {
  .button-container .button-not-fake::before {
    font-size: 10px;
  }
}
@media screen and (max-width: 480px) {
  .button-container .button-not-fake::before {
    font-size: 8px;
  }
}

.button-container .button-not-fake {
  opacity: 1.0;
  pointer-events: auto; 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;
  margin-left: 10px;
  margin-top: 0px;
  will-change: transform, opacity;
  transform: translateZ(0);
  cursor: pointer !important;
  transition: transform 0.3s ease;
  transform: scale(1); 
  position: relative;
  z-index: 3000;
}

.button-container .button-not-fake:hover {
  transform: scale(1.05);
}

.model-selector {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  z-index: 5000;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.model-selector select {
  background-color: #333;
  color: white;
  border: 1px solid #555;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 14px;
  cursor: pointer;
  outline: none;
}

.model-selector select:hover {
  background-color: #444;
}

.model-selector select:focus {
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
}

/* === PAINEL DE EXPLICAÇÃO === */
.explanation-panel {
  position: fixed;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 60dvw; /* 50% da largura total da tela */
  height: 60dvh; /* 50% da altura total da tela */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  will-change: transform, opacity;
  transform: translateZ(0) translateX(-50%);
}
@media screen and (max-width: 1024px) {
  .explanation-panel {
    width: 95dvw;
    height: 95dvh;
  }
}
/*
@media screen and (max-width: 768px) {
  .explanation-panel {
    width: 95dvw;
    height: 95dvh;
  }
}
*/

/* 
  style={{ flex: 1, maxWidth: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}

*/
.explanation-panel-content {
  flex: 1 1;
  max-width: '80dvw';
  display: 'flex';
  flex-direction: 'column';
  justify-content: 'space-between';
}

.explanation-panel-content-image {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  align-content: center;
  position: relative;
  width: auto;
  height: auto;
  margin: 0 50px;
  z-index: 2001;
  border-radius: 30px;
  border: 5px solid rgba(255, 255, 255, 0.1);
  pointer-events: auto;
  opacity: 0.95;
  overflow: hidden;
}

/* Seções do conteúdo da explicação */
.explanation-news-section {
  padding: 5px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 10;
  align-self: flex-start;
  height: auto;
}
@media screen and (max-width: 768px) {
  .airport-panel-content  {
    padding: 10px 3px;
  }
  .explanation-panel-content-image {
    width: auto;
    margin: 0 2px;
  }
  .explanation-news-section {
    width: auto;
    padding: 2px;
    margin: 2px;
  }
  .explanation-news-section h3 {
    font-size: 12px;
  }
  .explanation-news-section p {
    font-size: 10px;
  }
  .explanation-text-section h3 {
    font-size: 12px;
  }
  .explanation-text-section p {
    font-size: 10px;
  }
  .airport-panel-footer{
    top: auto;
    bottom: 0px;
    height: 6dvh;
  }
}
@media screen and (max-width: 480px) {
  .explanation-panel {
    width: 100dvw;
    height: fit-content;
  }
  .explanation-news-section {
    width: auto;
    padding: 1px;
  }
  .explanation-news-section h3 {
    font-size: 10px;
  }
  .explanation-news-section p {
    font-size: 8px;
  }
  .explanation-text-section {
    width: auto;
    padding: 1px;
  }
  .explanation-text-section h3 {
    font-size: 10px;
  }
  .explanation-text-section p {
    font-size: 8px;
  }
  .airport-panel-footer{
    top: auto;
    bottom: 0px;
    height: 4dvh;
  }
}

.explanation-news-section h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 18px;
  font-weight: bold;
  font-size: 14px;
}

.explanation-news-section p {
  margin: 5px;
  color: #2c3e50;
  line-height: 1.5;
  text-align: justify;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 12px;
  color:#6929fc;
}

/* === PAINEL DE STATUS DE ACERTOS === */
.hits-status-panel {
  position: fixed;
  left: 20%;
  bottom: 5%;
  width: 280px;
  height: auto;
  z-index: 900;
  border-radius: 15px;
  border: 2px solid #bbb;
  background: linear-gradient(to bottom, black, #040404); /* white degrades to light gray */
  box-shadow: 
    0 4px 8px rgba(0, 0, 0, 0.3),
    inset 0 2px 4px rgba(255, 255, 255, 0.3),
    inset 0 -2px 4px rgba(0, 0, 0, 0.3);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hits-status-text {
  color: white;
  font-family: 'Arial', sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  margin: 0;
}

.next-news-button {
  position: fixed;
  right: 6%;
  bottom: 5%;
  z-index: 1500;
  padding: 12px 22px;
  border-radius: 999px;
  border: 2px solid #3d7d0a;
  background: linear-gradient(180deg, #9be94a 0%, #5daf11 100%);
  color: #0f2a00;
  font-family: 'Arial', sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.4);
  cursor: pointer;
  box-shadow:
    0 3px 0 #3a6f0a,
    0 10px 20px rgba(0, 0, 0, 0.35);
  transform: translateZ(0);
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.next-news-button:hover {
  transform: translateY(-1px);
  box-shadow:
    0 7px 0 #3a6f0a,
    0 12px 22px rgba(0, 0, 0, 0.35);
}

.next-news-button:active {
  transform: translateY(3px);
  box-shadow:
    0 3px 0 #3a6f0a,
    0 6px 12px rgba(0, 0, 0, 0.35);
}

/* Desabilitado ao término da partida */
.next-news-button:disabled {
  cursor: not-allowed;
  filter: grayscale(1);
  opacity: 0.5;
  transform: none;
  box-shadow:
    0 3px 0 #3a6f0a,
    0 10px 20px rgba(0, 0, 0, 0.35);
}

@media screen and (max-width: 768px) {
  .hits-status-panel {
    width: auto;
    height: 20px;
    padding: 10px 12px;
    left: 5%;
    bottom: 2%;
  }
  
  .hits-status-text {
    font-size: 10px;
  }
}

@media screen and (max-width: 480px) {
  .hits-status-panel {
    width: auto;
    height: 20px;
    padding: 8px 10px;
    left: 3%;
    bottom: 1%;
  }
  
  .hits-status-text {
    font-size: 12px;
  }
}

.explanation-text-section {
  margin: 10px 0 10px 0;
  padding: 5px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 10;
  align-self: flex-end;
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  height: fit-content;
}

.explanation-text-section h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 14px;
  font-weight: bold;
}

.explanation-text-section p {
  margin: 5px;
  color: #2c3e50;
  font-size: 12px;
  line-height: 1.6;
  text-align: justify;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-weight: bold;
}

/* Botões do painel de explicação */
.explanation-buttons {
  display: flex;
  gap: 20px;
  margin-top: 2px;
  justify-content: center;
}

.explanation-button {
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  min-width: 120px;
  will-change: transform, opacity;
  transform: translateZ(0);
}
@media screen and (max-width: 768px) {
  .explanation-news-section p {
    font-size: 10px;
  }
  .explanation-news-section h3 {
    font-size: 12px;
  }
  .explanation-text-section p {
    font-size: 10px;
  }
  .explanation-text-section h3 {
    font-size: 12px;
  }
  .explanation-button {
    font-size: 10px;
    padding: 1px 2px;
    min-width: 80px;
  }
  .explanation-buttons {
    gap: 50%;
    margin-top: 2px;
    justify-content: center;
  }
}

.silence-button {
  background: linear-gradient(145deg, var(--jedi-pink), #c0392b);
  color: white;
  border: 2px solid #a93226;
}

.silence-button:hover {
  background: linear-gradient(145deg, #c0392b, #a93226);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);
}

.close-button {
  background: linear-gradient(145deg, var(--jedi-blue), #2980b9);
  color: white;
  border: 2px solid #2471a3;
}

.close-button:hover {
  background: linear-gradient(145deg, #2980b9, #2471a3);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4);
}

.explanation-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

/* Estilos para o carimbo FAKE */
.fake-news-stamp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  /* Animação de zoom out - como se o carimbo descesse sobre a notícia */
  animation: stampZoomOut 5s ease-out forwards;
  z-index: 3000;
}

.fake-stamp-image {
  width: 100px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.4));
  transform: rotate(-15deg);
}

/* Animação do carimbo - efeito de zoom out */
@keyframes stampZoomOut {
  0% {
    transform: translate(-50%, -50%) scale(10) rotate(-15deg);
    opacity: 0;
  }
  20% {
    transform: translate(-50%, -50%) scale(1.3) rotate(-15deg);
    opacity: 0.8;
  }
  40% {
    transform: translate(-50%, -50%) scale(0.9) rotate(-15deg);
    opacity: 0.95;
  }
  60% {
    transform: translate(-50%, -50%) scale(1.1) rotate(-15deg);
    opacity: 0.9;
  }
  80% {
    transform: translate(-50%, -50%) scale(0.95) rotate(-15deg);
    opacity: 0.92;
  }
  100% {
    transform: translate(-50%, -50%) scale(1) rotate(-15deg);
    opacity: 0.9;
  }
}

/* Estilo específico para o carimbo no painel de explicação */
.fake-news-stamp.explanation-stamp {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 15;
  pointer-events: none;
  /* Animação de zoom out - como se o carimbo descesse sobre a notícia */
  animation: stampZoomOut 12s ease-out forwards;
}

.explanation-stamp .fake-stamp-image {
  width: 120px;
  height: auto;
  opacity: 0.85;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transform: rotate(-20deg);
}

/* Variação para dispositivos móveis */
@media (max-width: 768px) {
  .fake-stamp-image {
    width: 150px;
  }
  
  .explanation-stamp .fake-stamp-image {
    width: 90px;
  }
}

@media (max-width: 480px) {
  .fake-stamp-image {
    width: 120px;
  }
  
  .explanation-stamp .fake-stamp-image {
    width: 80px;
  }
}

/* === PAINEL DE VITÓRIA/CONCLUSÃO === */
.victory-panel {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65dvw;
  height: 65dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  will-change: transform, opacity;
  z-index: 1200;
}

.victory-panel-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
  background: rgba(255, 255, 255, 0.95);
  border-radius: 30px;
  padding: 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 5px solid rgba(255, 255, 255, 0.3);
  animation: victorySlideIn 0.8s ease-out;
  width: 100%;
  height: 100%;
  z-index: 9001;
}

.victory-image-container {
  margin-bottom: 20px;
  animation: victoryImageBounce 1s ease-in-out infinite alternate;
}

.victory-image {
  width: 300px;
  height: auto;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));
}

.victory-title {
  font-size: 4rem;
  font-weight: bold;
  color: var(--jedi-violet);
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
  margin: 20px 0;
  animation: victoryTitlePulse 1.5s ease-in-out infinite;
}

.restart-button {
  margin-top: 30px;
  padding: 20px 60px;
  font-size: 1.8rem;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(135deg, var(--jedi-green) 0%, var(--jedi-dark-green) 100%);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.restart-button:hover {
  transform: scale(1.1);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);
}

.restart-button:active {
  transform: scale(0.95);
}

/* Animações do painel de vitória */
@keyframes victorySlideIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes victoryImageBounce {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-10px);
  }
}

@keyframes victoryTitlePulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* Responsividade do painel de vitória */
@media screen and (max-width: 1024px) {
  .victory-panel {
    width: 90dvw;
    height: 80dvh;
  }
  
  .victory-image {
    width: 200px;
  }
  
  .victory-title {
    font-size: 3rem;
  }
  
  .restart-button {
    padding: 15px 40px;
    font-size: 1.4rem;
  }
}

@media screen and (max-width: 768px) {
  .victory-panel {
    width: 95dvw;
    height: 85dvh;
  }
  
  .victory-image {
    width: 150px;
  }
  
  .victory-title {
    font-size: 2.5rem;
  }
  
  .restart-button {
    padding: 12px 30px;
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 480px) {
  .victory-panel {
    width: 100dvw;
    height: 90dvh;
  }
  
  .victory-panel-content {
    padding: 20px;
  }
  
  .victory-image {
    width: 120px;
  }
  
  .victory-title {
    font-size: 2rem;
  }
  
  .restart-button {
    padding: 10px 25px;
    font-size: 1rem;
  }
}

/* === RESPONSIVIDADE DO JOGO COMPLETO === */

/* Container wrapper que preenche toda a viewport */
.game-viewport-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(0, 0, 128);
}

/* Container escalável que se adapta à viewport */
.game-responsive {
  /* Será escalado via CSS custom properties (variáveis) */
  transform: scale(var(--game-scale, 1));
  transform-origin: center center;
  /* Garantir que não cause overflow */
  will-change: transform;
}

/* Cálculo de escala usando CSS clamp para diferentes viewports */
:root {
  /* Escala baseada na largura da viewport */
  --scale-width: calc(100vw / 1920);
  /* Escala baseada na altura da viewport */
  --scale-height: calc(100vh / 1080);
  /* Usar a menor escala para garantir que tudo caiba */
  --game-scale: min(var(--scale-width), var(--scale-height));
}

/* Ajuste específico para modo retrato em dispositivos móveis */
@media (max-width: 768px) and (orientation: portrait) {
  :root {
    --scale-width: calc(100vw / 1920);
    --scale-height: calc(100vh / 1200); /* Ajuste para retrato */
    --game-scale: min(var(--scale-width), var(--scale-height));
  }
  
  .isometric-container {
    padding: 10px; /* Margem de segurança */
  }
}

/* Game Container e Viewport Classes */
.game-viewport-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #000;
  z-index: 1;
}

.game-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--jedi-violet);
}

.game-responsive {
  transform-origin: center center;
  transform: scale(var(--scale, 1));
  transition: transform 0.3s ease;
}

/* Portrait Warning Overlay */
.portrait-warning-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  color: var(--jedi-green);
  text-align: center;
  font-family: Arial, sans-serif;
  animation: pulse 2s infinite;
}

.portrait-warning-text {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 2rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
}

.portrait-warning-subtitle {
  font-size: 1.5rem;
  margin-bottom: 3rem;
  opacity: 0.9;
}

.portrait-warning-icon {
  font-size: 8rem;
  margin-bottom: 2rem;
  animation: rotate 5s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.8; }
  50% { opacity: 1; }
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  50% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* === BOTÃO DE TELA CHEIA === */
.fullscreen-button {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.7);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: white;
  cursor: pointer;
  padding: 12px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.fullscreen-button:hover {
  background: rgba(0, 0, 0, 0.8);
  border-color: rgba(255, 255, 255, 0.6);
  transform: scale(1.05);
}

.fullscreen-button:active {
  transform: scale(0.95);
}

.fullscreen-button svg {
  display: block;
  width: 24px;
  height: 24px;
}

/* Responsividade para dispositivos móveis */
@media (max-width: 768px) {
  .fullscreen-button {
    top: 15px;
    left: 15px;
    padding: 10px;
  }
  
  .fullscreen-button svg {
    width: 20px;
    height: 20px;
  }
}

/* === ESTADOS DE TELA CHEIA === */
/* Quando em tela cheia, ajustar alguns elementos se necessário */
:fullscreen .game-viewport-container,
:-webkit-full-screen .game-viewport-container,
:-moz-full-screen .game-viewport-container,
:-ms-fullscreen .game-viewport-container {
  /* Garantir que o container ocupe toda a tela disponível */
  width: 100vw;
  height: 100vh;
}

/* Esconder elementos desnecessários em tela cheia */
:fullscreen .fullscreen-button,
:-webkit-full-screen .fullscreen-button,
:-moz-full-screen .fullscreen-button,
:-ms-fullscreen .fullscreen-button {
  /* Manter o botão visível mesmo em tela cheia */
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10001;
}

/* Ajustes específicos para dispositivos móveis */
@media (max-width: 768px) {
  /* Ajustar z-index para melhor layering em mobile */
  .game-info {
    z-index: 200;
    font-size: 0.9rem;
  }
  
  .debug-overlay {
    z-index: 200;
    font-size: 0.8rem;
  }
  
  .model-selector {
    z-index: 5001;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .game-info {
    padding: 10px;
    font-size: 0.8rem;
  }
  
  .debug-overlay {
    padding: 8px 12px;
    font-size: 0.75rem;
  }
  
  .model-selector {
    font-size: 0.8rem;
    padding: 6px 10px;
  }
}

/* Ajustes para orientação landscape em dispositivos móveis */
@media (max-height: 600px) and (orientation: landscape) {
  .game-info {
    top: 10px;
    left: 10px;
    padding: 8px 12px;
    font-size: 0.75rem;
  }
  
  .debug-overlay {
    bottom: 10px;
    left: 10px;
    padding: 6px 10px;
    font-size: 0.7rem;
  }
  
  .model-selector {
    top: 5px;
    right: 5px;
    padding: 4px 8px;
    font-size: 0.7rem;
  }
}

/* === SKATE MAGNÉTICO (flutua no lugar) === */
.skate-container {
  position: relative;
  display: inline-block;
}

/* Aura exagerada e bem visível */
.skate-container.skate-active-effect::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 520px;
  height: 260px;
  background: radial-gradient(circle, rgba(0,180,255,0.9) 0%, rgba(0,150,255,0.6) 35%, rgba(0,100,255,0.3) 60%, transparent 85%);
  filter: blur(90px) saturate(150%);
  transform: translate(-50%, -50%) scale(1.1);
  z-index: 0;
  animation: glowPulse 2.0s ease-in-out infinite;
}

@keyframes glowPulse {
  0%, 100% {
    opacity: 0.8;
    filter: blur(90px) saturate(150%);
    transform: translate(-50%, -50%) scale(1.1);
  }
  50% {
    opacity: 1;
    filter: blur(120px) saturate(200%);
    transform: translate(-50%, -50%) scale(1.25);
  }
}

.skate-container.skate-active-effect .skate-mag-image {
  position: relative;
  z-index: 1;
  width: 320px;
  height: auto;
  display: block;
  filter: drop-shadow(0 0 45px rgba(0, 100, 255, 0.9)) drop-shadow(0 0 90px rgba(0, 200, 255, 0.6));
  animation: skateAura 2.0s ease-in-out infinite;
}

@keyframes skateAura {
  0%, 100% {
    filter: drop-shadow(0 0 15px rgba(0, 100, 255, 0.9)) drop-shadow(0 0 30px rgba(0, 0, 255, 0.6));
    top: 0px;
  }
  50% {
    filter: drop-shadow(0 0 30px rgba(0, 200, 255, 1)) drop-shadow(0 0 45px rgba(0, 100, 255, 0.9));
    top: -3px;
  }
}

/* === CONTAINER DO PORTAL DE DESMATERIALIZAÇÃO === */
.portal-container {
  position: absolute;
  pointer-events: none;
  width: 300px;
  height: 300px;
  scale: 1;
}
/* Aura exagerada e bem visível */
.portal-container.portal-active-effect::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 520px;
  height: 260px;
  background: radial-gradient(circle, rgba(255,0,0,0.9) 0%, rgba(255,64,64,0.6) 35%, rgba(0,100,255,0.3) 60%, transparent 85%);
  filter: blur(30px) saturate(50%);
  transform: translate(-50%, -50%) scale(1.1);
  z-index: 0;
  animation: glowPulse 0.2s ease-in-out infinite;
}

.portal-container.portal-active-effect .portal-image {
  position: relative;
  z-index: 1;
  width: 320px;
  height: auto;
  display: block;
  filter: drop-shadow(0 0 15px rgba(255,63,63, 0.9)) drop-shadow(0 0 30px rgba(255,32,32, 0.6));
  animation: portalAura 0.2s ease-in-out infinite;
}

@keyframes portalAura {
  0%, 100% {
    filter: drop-shadow(0 0 5px rgba(255,63,63, 0.9)) drop-shadow(0 0 10px rgba(255,32,32, 0.6));
    top: 0px;
  }
  50% {
    filter: drop-shadow(0 0 10px rgba(255,32,32, 1)) drop-shadow(0 0 15px rgba(255,63,63, 0.9));
    top: -3px;
  }
}

/* FIM DO PORTAL DE DESMATERIALIZAÇÃO */

/* === EFEITO PULSANTE DAS PÍLULAS === */
.pirula-container {
  position: absolute;
  pointer-events: none;
}

.pirula-container .pirula-image {
  position: relative;
  display: block;
  z-index: 1;
}

.pirula-container.pirula-active-effect::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  filter: blur(28px) saturate(140%);
  transform: translate(-50%, -50%) scale(1);
  z-index: 0;
  animation: pillGlowPulse 0.5s ease-in-out infinite;
}

.pirula-container.pirula-active-effect .pirula-image {
  animation: pillAura 1.8s ease-in-out infinite;
}

/* Cores por atributo data-pill-color */
.pirula-container.pirula-active-effect[data-pill-color="vermelha"]::before {
  background: radial-gradient(circle, rgba(255,50,50,0.85) 0%, rgba(255,80,80,0.5) 40%, transparent 80%);
}
.pirula-container.pirula-active-effect[data-pill-color="vermelha"] .pirula-image {
  filter: drop-shadow(0 0 12px rgba(255,50,50,0.9)) drop-shadow(0 0 24px rgba(255,80,80,0.5));
}

.pirula-container.pirula-active-effect[data-pill-color="amarela"]::before {
  background: radial-gradient(circle, rgba(255,200,0,0.85) 0%, rgba(255,220,60,0.5) 40%, transparent 80%);
}
.pirula-container.pirula-active-effect[data-pill-color="amarela"] .pirula-image {
  filter: drop-shadow(0 0 12px rgba(255,200,0,0.9)) drop-shadow(0 0 24px rgba(255,220,60,0.5));
}

.pirula-container.pirula-active-effect[data-pill-color="azul"]::before {
  background: radial-gradient(circle, rgba(0,120,255,0.85) 0%, rgba(60,160,255,0.5) 40%, transparent 80%);
}
.pirula-container.pirula-active-effect[data-pill-color="azul"] .pirula-image {
  filter: drop-shadow(0 0 12px rgba(0,120,255,0.9)) drop-shadow(0 0 24px rgba(60,160,255,0.5));
}

.pirula-container.pirula-active-effect[data-pill-color="verde"]::before {
  background: radial-gradient(circle, rgba(0,200,80,0.85) 0%, rgba(60,220,120,0.5) 40%, transparent 80%);
}
.pirula-container.pirula-active-effect[data-pill-color="verde"] .pirula-image {
  filter: drop-shadow(0 0 12px rgba(0,200,80,0.9)) drop-shadow(0 0 24px rgba(60,220,120,0.5));
}

@keyframes pillGlowPulse {
  0%, 100% {
    opacity: 0.7;
    transform: translate(-50%, -50%) scale(1);
  }
  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(2.4);
  }
}

@keyframes pillAura {
  0%, 100% {
    top: 0px;
  }
  50% {
    top: -3px;
  }
}
/* FIM DO EFEITO PULSANTE DAS PÍLULAS */




img {
  width: 320px;
  height: auto;
  display: block;
  margin: 0 !important;
  padding: 0 !important;
  overflow: visible;
}

/* === TROFÉU FLUTUANTE (flutua no lugar) === */
.ranking-image {
  animation: objFloat 2.8s ease-in-out infinite;
  will-change: transform;
}

@keyframes objFloat {
  0%, 100% {
    margin-top: 0px;
  }
  50% {
    top: -16px;
    margin-top: -8px;
  }
}

/* === PORTAL DE DESMATERIALIZAÇÃO - ANIMAÇÕES === */

/* Container do player com efeito de portal */
.player.portal-dematerializing,
.player.portal-rematerializing {
  position: relative;
}

/* Pseudo-elemento para aura mágica atrás do player */
.player.portal-dematerializing::before,
.player.portal-rematerializing::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(205, 143, 255, 0.75) 0%, rgba(95, 203, 255, 0.45) 45%, transparent 72%);
  filter: blur(10px);
  transform: translate(-50%, -50%) scale(0.35);
  z-index: -1;
  pointer-events: none;
  opacity: 0;
}

/* Pseudo-elemento para partículas mágicas */
.player.portal-dematerializing::after,
.player.portal-rematerializing::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200%;
  height: 200%;
  background:
    radial-gradient(circle, rgba(255, 255, 255, 0.98) 0 8%, transparent 10%) 15% 78% / 34px 34px no-repeat,
    radial-gradient(circle, rgba(199, 238, 255, 0.9) 0 10%, transparent 12%) 75% 70% / 40px 40px no-repeat,
    radial-gradient(circle, rgba(196, 159, 255, 0.9) 0 9%, transparent 11%) 62% 86% / 30px 30px no-repeat,
    radial-gradient(circle, rgba(150, 215, 255, 0.95) 0 8%, transparent 10%) 36% 62% / 26px 26px no-repeat,
    radial-gradient(circle, rgba(255, 255, 255, 0.95) 0 8%, transparent 10%) 52% 82% / 24px 24px no-repeat;
  mix-blend-mode: screen;
  transform: translate(-50%, -50%) translateY(26px) scale(0.75);
  z-index: 1;
  pointer-events: none;
  opacity: 0;
}

/* Animação de DESMATERIALIZAÇÃO (sprite desaparece) */
.player.portal-dematerializing .player-sprite {
  animation: portal-arcane-vanish 4s ease forwards;
}

.player.portal-dematerializing::before {
  animation: portal-arcane-burst 4s ease forwards;
}

.player.portal-dematerializing::after {
  animation: portal-sparkles-rise 4s ease forwards;
}

/* Animação de REMATERIALIZAÇÃO (sprite aparece) */
/* NOTA: Usamos keyframes separados (portal-arcane-appear) em vez de 'reverse' 
   porque o browser não reinicia corretamente a animação quando o elemento 
   já está no estado final da animação anterior */
.player.portal-rematerializing .player-sprite {
  animation: portal-arcane-appear 4s ease forwards;
}

.player.portal-rematerializing::before {
  animation: portal-arcane-burst-appear 4s ease forwards;
}

.player.portal-rematerializing::after {
  animation: portal-sparkles-descend 4s ease forwards;
}

/* Keyframes - Efeito de desaparecimento mágico do sprite (DESMATERIALIZAÇÃO) */
@keyframes portal-arcane-vanish {
  0% {
    opacity: 1;
    transform: scale(1);
    filter: drop-shadow(0 10px 25px rgba(0, 0, 0, 0.6)) brightness(1) saturate(1);
  }
  35% {
    opacity: 1;
    filter: drop-shadow(0 0 24px rgba(197, 140, 255, 0.9)) brightness(1.28) saturate(1.7);
  }
  100% {
    opacity: 0;
    transform: scale(0.86) translateY(-9px);
    filter: blur(7px) brightness(1.9) saturate(2.1);
  }
}

/* Keyframes - Efeito de aparecimento mágico do sprite (REMATERIALIZAÇÃO) */
@keyframes portal-arcane-appear {
  0% {
    opacity: 0;
    transform: scale(0.86) translateY(-9px);
    filter: blur(7px) brightness(1.9) saturate(2.1);
  }
  65% {
    opacity: 1;
    filter: drop-shadow(0 0 24px rgba(197, 140, 255, 0.9)) brightness(1.28) saturate(1.7);
  }
  100% {
    opacity: 1;
    transform: scale(1);
    filter: drop-shadow(0 10px 25px rgba(0, 0, 0, 0.6)) brightness(1) saturate(1);
  }
}

/* Keyframes - Explosão da aura mágica (DESMATERIALIZAÇÃO) */
@keyframes portal-arcane-burst {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.25);
  }
  25% {
    opacity: 0.95;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.35);
  }
}

/* Keyframes - Contração da aura mágica (REMATERIALIZAÇÃO) */
@keyframes portal-arcane-burst-appear {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.35);
  }
  75% {
    opacity: 0.95;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.25);
  }
}

/* Keyframes - Partículas mágicas subindo (DESMATERIALIZAÇÃO) */
@keyframes portal-sparkles-rise {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) translateY(26px) scale(0.75);
  }
  30% {
    opacity: 0.95;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) translateY(-30px) scale(1.15);
  }
}

/* Keyframes - Partículas mágicas descendo (REMATERIALIZAÇÃO) */
@keyframes portal-sparkles-descend {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) translateY(-30px) scale(1.15);
  }
  70% {
    opacity: 0.95;
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) translateY(26px) scale(0.75);
  }
}

/* === Help popup (usado no tabuleiro para desafios) === */
.help-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10010;
}

.help-card {
  position: relative;
  background: rgba(10, 10, 30, 0.92);
  border: 1px solid rgba(196, 222, 29, 0.35);
  border-radius: 16px;
  width: min(800px, 92vw);
  max-height: 90vh;
  max-height: 90dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  animation: helpCardFadeIn 0.25s ease-out;
  overflow-y: auto;
}

@keyframes helpCardFadeIn {
  from { opacity: 0; transform: scale(0.95) translateY(10px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.help-card-close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 1.1rem;
  cursor: pointer;
  z-index: 1;
}

.help-card-close:hover {
  color: #fff;
}

.help-card-title {
  margin: 0;
  padding: 18px 20px 10px;
  font-size: 1.5rem;
  color: var(--jedi-green, #c4de1d);
  text-align: center;
  flex-shrink: 0;
}

.help-card-body {
  padding: 4px 20px 20px;
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
}

.help-section {
  margin-bottom: 14px;
}

.help-section-title {
  margin: 0 0 4px;
  font-size: 1.3rem;
  color: #fff;
}

.help-section-text {
  margin: 0 0 6px;
  font-size: 1.25rem;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.82);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA,oBAAoB,YAAY,EAAE;AAClC,OAAO,SAAS,EAAE,gBAAgB,EAAE;;AAEpC;AACA,sBAAsB;AACtB,oBAAoB;AACpB,sBAAsB;AACtB,oBAAoB;AACpB,0BAA0B;AAC1B,0BAA0B;AAC1B,0BAA0B;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,oBAAoB;EACpB,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,uCAAuC;AACzC;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,yCAAyC;EACzC,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA,8DAA8D;AAC9D;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,0BAA0B,2BAA2B,EAAE;EACvD,qBAAqB,0BAA0B,EAAE;AACnD;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;;;EAGb;;;;;;;;;;;;CAYD;;AAED,UAAU;AACV,mBAAmB,EAAE,4CAA4C;AACjE,sBAAsB,EAAE,8DAA8D;AACtF,kBAAkB,EAAE,0DAA0D;AAC9E,gBAAgB,EAAE,8CAA8C;;AAEhE,mDAAmD;AACnD,+FAA+F;AAC/F;;;;;CAKC;;AAED,iEAAiE;AACjE,6BAA6B,EAAE,sDAAsD;AACrF,oEAAoE;AACpE,6EAA6E;;AAE7E,gEAAgE;AAChE;;;;;;;kCAOkC,EAAE,uCAAuC;;;AAG3E;;AAEA;EACE,SAAO;EACP,aAAa;AACf,wFAAwF;EACtF,wDAAwD,EAAE,iCAAiC;EAC3F,4BAA4B;;EAE5B,uBAAuB;EACvB,kBAAkB;;EAElB,YAAY;;EAEZ,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;KAOG;EACH,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB;;;;GAIC;AACH;;AAEA,wCAAwC;AACxC;EACE,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;;EAE5B,SAAS;EACT,WAAW;EACX,YAAY;;EAEZ,uBAAuB;EACvB,6BAA6B;EAC7B;;uCAEqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY,EAAE,4BAA4B;EAC1C,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;;EAE3C,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,gDAAgD;EAChD,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,2CAA2C;EAC3C,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yDAAmD;EACnD,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yDAAuD;EACvD,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,YAAY,EAAE,iCAAiC;EAC/C,aAAa,EAAE,gCAAgC;EAC/C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,yCAAyC;AAC3C;AACA;EACE;IACE,YAAY;IACZ,aAAa;EACf;AACF;AACA;;;;;;;CAOC;;AAED;;;CAGC;AACD;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;EACzC,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,YAAY;AACd;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;IACT,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gDAAgD;EAChD,eAAe;EACf,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,sDAAsD,EAAE,iCAAiC;EACzF;;;uCAGqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,6DAA6D;EAC7D,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,+CAA+C;EAC/C,eAAe;EACf;;mCAEiC;EACjC,wBAAwB;EACxB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;mCAEiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B;;kCAEgC;AAClC;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf;;mCAEiC;AACnC;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;EACzC,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,QAAQ;IACR,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE,8DAA8D;EAC9D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,8DAA8D;EAC9D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,sEAAsE;EACtE,4CAA4C;EAC5C,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA,6CAA6C;AAC7C;EACE;IACE,yDAAyD;IACzD,UAAU;EACZ;EACA;IACE,0DAA0D;IAC1D,YAAY;EACd;EACA;IACE,0DAA0D;IAC1D,aAAa;EACf;EACA;IACE,0DAA0D;IAC1D,YAAY;EACd;EACA;IACE,2DAA2D;IAC3D,aAAa;EACf;EACA;IACE,wDAAwD;IACxD,YAAY;EACd;AACF;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,oBAAoB;EACpB,sEAAsE;EACtE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mEAAmE;EACnE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,0CAA0C;EAC1C,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,2CAA2C;EAC3C,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,sFAAsF;EACtF,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,4CAA4C;;AAE5C,mDAAmD;AACnD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,iDAAiD;AACjD;EACE,wDAAwD;EACxD,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,iEAAiE;AACjE;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,yCAAyC;EACzC,kCAAkC;EAClC,qDAAqD;EACrD,0DAA0D;AAC5D;;AAEA,+DAA+D;AAC/D;EACE;IACE,iCAAiC;IACjC,kCAAkC,EAAE,wBAAwB;IAC5D,0DAA0D;EAC5D;;EAEA;IACE,aAAa,EAAE,wBAAwB;EACzC;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,MAAM,uBAAuB,EAAE;EAC/B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,cAAc;EACd,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE;IACE,SAAS;IACT,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC,iEAAiE;AACjE;;;;EAIE,0DAA0D;EAC1D,YAAY;EACZ,aAAa;AACf;;AAEA,oDAAoD;AACpD;;;;EAIE,+CAA+C;EAC/C,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,mDAAmD;EACnD;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,6DAA6D;AAC7D;EACE;IACE,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8HAA8H;EAC9H,iCAAiC;EACjC,2CAA2C;EAC3C,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE;IACE,YAAY;IACZ,iCAAiC;IACjC,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,kCAAkC;IAClC,4CAA4C;EAC9C;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iGAAiG;EACjG,8CAA8C;AAChD;;AAEA;EACE;IACE,+FAA+F;IAC/F,QAAQ;EACV;EACA;IACE,+FAA+F;IAC/F,SAAS;EACX;AACF;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;AACA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,4HAA4H;EAC5H,gCAAgC;EAChC,2CAA2C;EAC3C,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,6FAA6F;EAC7F,+CAA+C;AACjD;;AAEA;EACE;IACE,4FAA4F;IAC5F,QAAQ;EACV;EACA;IACE,2FAA2F;IAC3F,SAAS;EACX;AACF;;AAEA,uCAAuC;;AAEvC,wCAAwC;AACxC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,yCAAyC;EACzC,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,uCAAuC;AACvC;EACE,sGAAsG;AACxG;AACA;EACE,2FAA2F;AAC7F;;AAEA;EACE,uGAAuG;AACzG;AACA;EACE,4FAA4F;AAC9F;;AAEA;EACE,uGAAuG;AACzG;AACA;EACE,4FAA4F;AAC9F;;AAEA;EACE,sGAAsG;AACxG;AACA;EACE,2FAA2F;AAC7F;;AAEA;EACE;IACE,YAAY;IACZ,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;AACF;AACA,uCAAuC;;;;;AAKvC;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA,oDAAoD;;AAEpD,6CAA6C;AAC7C;;EAEE,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gHAAgH;EAChH,kBAAkB;EAClB,4CAA4C;EAC5C,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA,4CAA4C;AAC5C;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ;;;;;0GAKwG;EACxG,sBAAsB;EACtB,6DAA6D;EAC7D,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA,sDAAsD;AACtD;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,kDAAkD;AAClD;;iDAEiD;AACjD;EACE,gDAAgD;AAClD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;AACrD;;AAEA,+EAA+E;AAC/E;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,6EAA6E;EAC/E;EACA;IACE,UAAU;IACV,qFAAqF;EACvF;EACA;IACE,UAAU;IACV,uCAAuC;IACvC,+CAA+C;EACjD;AACF;;AAEA,2EAA2E;AAC3E;EACE;IACE,UAAU;IACV,uCAAuC;IACvC,+CAA+C;EACjD;EACA;IACE,UAAU;IACV,qFAAqF;EACvF;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,6EAA6E;EAC/E;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,UAAU;IACV,6DAA6D;EAC/D;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,8DAA8D;EAChE;AACF;;AAEA,+DAA+D;AAC/D;EACE;IACE,UAAU;IACV,8DAA8D;EAChE;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,6DAA6D;EAC/D;AACF;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC","sourcesContent":["\r\nhtml, body, #root { height: 100%; }\r\nbody { margin: 0; background: #000; }\r\n\r\n:root {\r\n--jedi-violet: #6929fc;\r\n--jedi-blue: #5cc6d0;\r\n--jedi-green:  #c4de1d;\r\n--jedi-pink: #ec62ff;\r\n--jedi-dark-green: #647e0d;\r\n--jedi-background: #3f219b;\r\n--jedi-main-title: #bfe9ec;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.game-container {\r\n  position: relative;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: rgb(0, 0, 128);\r\n  overflow: hidden;\r\n  /* Permitir que o container seja escalado */\r\n  transform-origin: center center;\r\n}\r\n\r\n/* Camada isolada para UI (painéis, botões) - melhora composição */\r\n.ui-layer {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 20000;\r\n  pointer-events: none;\r\n}\r\n\r\n.ui-layer > * {\r\n  pointer-events: auto;\r\n}\r\n\r\n.game-exit-button {\r\n  position: absolute;\r\n  top: 14px;\r\n  right: 14px;\r\n  z-index: 2000;\r\n  border: 1px solid rgba(196, 222, 29, 0.65);\r\n  border-radius: 999px;\r\n  background: rgba(0, 0, 0, 0.55);\r\n  color: var(--jedi-green);\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.board-container {\r\n  position: absolute;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: hidden;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.game-info {\r\n  position: absolute;\r\n  top: 20px;\r\n  left: 20px;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  color: white;\r\n  padding: 15px;\r\n  border-radius: 10px;\r\n  z-index: 100;\r\n  font-weight: bold;\r\n  box-shadow: 0 0 15px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.debug-overlay {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  left: 20px;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  color: white;\r\n  padding: 10px 15px;\r\n  border-radius: 8px;\r\n  z-index: 100;\r\n  font-family: monospace;\r\n  font-size: 14px;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n/* Estilos para visualização de debug do jogador */\r\n.debug-grid-cell {\r\n  position: absolute;\r\n  width: 64px;\r\n  height: 32px;\r\n  border: 1px dashed rgba(255, 255, 255, 0.5);\r\n  transform: rotateX(60deg) rotateZ(-45deg);\r\n  transform-style: preserve-3d;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Garantir que elementos 3D sejam renderizados corretamente */\r\n* {\r\n  transform-style: preserve-3d;\r\n  backface-visibility: hidden;\r\n}\r\n\r\n/* Classes para animações */\r\n.shake {\r\n  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;\r\n}\r\n\r\n.fade-in {\r\n  animation: fadeIn 0.5s ease-in;\r\n}\r\n\r\n.pulse {\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\r\n  20%, 40%, 60%, 80% { transform: translateX(5px); }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { transform: scale(1); }\r\n  50% { transform: scale(1.05); }\r\n  100% { transform: scale(1); }\r\n}\r\n\r\n/* Estilos para transformações 3D */\r\n.isometric-board, .tile, .player, .dice, .dice-face {\r\n  transform-style: preserve-3d;\r\n  -webkit-transform-style: preserve-3d;\r\n  -moz-transform-style: preserve-3d;\r\n  backface-visibility: hidden;\r\n  -webkit-backface-visibility: hidden;\r\n  -moz-backface-visibility: hidden;\r\n}\r\n\r\n.news-board {\r\n  position: fixed;\r\n  top: 10%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 50%;\r\n  height: auto;\r\n  z-index: 7000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: auto;\r\n  will-change: transform, opacity;\r\n  transform: translateZ(0) translateX(-50%);\r\n}\r\n\r\n.news-board-content-image {\r\n  position: relative;\r\n  width: 60dvw;\r\n  height: 30dvh;\r\n  margin: 0 50px;\r\n  z-index: 7001;\r\n  border-radius: 30px;\r\n  border: 5px solid rgba(255, 255, 255, 0.1);\r\n  pointer-events: auto;\r\n  opacity: 1;\r\n  overflow: hidden;\r\n  will-change: transform, opacity;\r\n  transform: translateZ(0);\r\n}\r\n\r\n/* Painel estilo aeroporto */\r\n.airport-panel {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: 25px;\r\n  overflow-y: auto; \r\n  z-index: 6000;\r\n\r\n  \r\n  /* Se precisar de efeito 3D nas bordas manipular as cores das bordas * /\r\n  border: 9px solid #bbb;\r\n  /* Efeito de degradê #007 #00F #007 simulando um cano iluminado * /\r\n  border-top-color: linear-gradient(to bottom, #007, #00F, #007);\r\n  border-left-color: linear-gradient(to right, #007, #00F, #007);\r\n  border-right-color: linear-gradient(to left, #007, #00F, #007);\r\n  border-bottom-color: linear-gradient(to bottom, #007, #00F, #007);\r\n  \r\n  /* Sombra interna para efeito de profundidade * /\r\n  box-shadow: \r\n    inset 2px 2px 4px rgba(255, 255, 255, 0.8),\r\n    inset -2px -2px 4px rgba(0, 0, 0, 0.2);\r\n*/\r\n\r\nopacity: 1;\r\nborder-radius: 25px; /* Metade da altura para um formato roliço */\r\nbox-sizing: border-box; /* Garante que padding e border não aumentem o tamanho total */\r\nposition: relative; /* Pode ser útil para pseudo-elementos ou posicionamento */\r\noverflow: hidden; /* Garante que o gradiente de fundo não vaze */\r\n\r\n/* Fundo do cano com gradiente radial para volume */\r\n/* old-background: radial-gradient(circle at 50% 50%, #44AADD 0%, #0077BB 70%, #004488 100%); */\r\nbackground: radial-gradient(\r\n  circle at 50% 50%,\r\n  rgba(68, 170, 221, 0.35) 0%,\r\n  rgba(0, 119, 187, 0.4) 70%,\r\n  rgba(0, 68, 136, 0.45) 100%\r\n);\r\n\r\n/* Borda com gradiente para simular reflexo/iluminação na borda */\r\nborder: 4px solid transparent; /* Largura da borda que o border-image vai preencher */\r\nborder-image: linear-gradient(to right, #0077BB, #44AADD, #0077BB) 1;\r\n/* O '1' é para border-image-slice, estendendo o gradiente por toda a borda */\r\n\r\n/* Múltiplas sombras para profundidade, brilho e efeito roliço */\r\nbox-shadow:\r\n  /* Sombra interna para luz no topo e sombra na base (efeito 3D roliço) */\r\n  inset 0 2px 5px rgba(255, 255, 255, 0.4), /* Luz no topo (quase branco) */\r\n  inset 0 -2px 5px rgba(0, 0, 0, 0.3),   /* Sombra na parte inferior (quase preto) */\r\n\r\n  /* Brilho externo sutil (iluminação geral) */\r\n  0 0 10px rgba(68, 173, 221, 0.6), /* Brilho azul mais forte */\r\n  0 0 20px rgba(68, 173, 221, 0.3); /* Brilho azul mais suave e espalhado */\r\n\r\n\r\n}\r\n\r\n.airport-panel-content {\r\n  flex: 1;\r\n  padding: 20px;\r\n/*  background: linear-gradient(to bottom, var(--jedi-green), var(--jedi-dark-green)); */\r\n  background: linear-gradient(to bottom, #777777, #444444); /* white degrades to light gray */\r\n  border-radius: 22px 22px 0 0;\r\n  \r\n  /* Efeito de tela LCD */\r\n  position: relative;\r\n\r\n  height: auto;\r\n  \r\n  /* Layout flexível para as seções de explicação */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.airport-panel-content::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: \r\n    repeating-linear-gradient(\r\n      90deg,\r\n      transparent,\r\n      transparent 2px,\r\n      rgba(0, 0, 0, 0.03) 2px,\r\n      rgba(0, 0, 0, 0.03) 4px\r\n    );\r\n  pointer-events: none;\r\n  border-radius: 22px 22px 0 0;\r\n}\r\n\r\n.airport-panel-content--news {\r\n  box-sizing: border-box;\r\n  min-height: 0;\r\n  overflow: hidden;\r\n  background: linear-gradient(\r\n    to bottom,\r\n    rgba(119, 119, 119, 0.65),\r\n    rgba(68, 68, 68, 0.68)\r\n  );\r\n}\r\n\r\n/* Faixa azul escura na parte inferior */\r\n.airport-panel-footer {  \r\n  background: linear-gradient(to bottom, #3f51b5, var(--jedi-violet));\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-radius: 0 0 22px 22px;\r\n  \r\n  top: auto;\r\n  bottom: 0px;\r\n  height: 6dvh;\r\n  \r\n  /* Efeito 3D na faixa */\r\n  border-top: 2px solid #3f51b5;\r\n  box-shadow: \r\n    inset 0 2px 4px rgba(255, 255, 255, 0.3),\r\n    inset 0 -2px 4px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Texto rolante */\r\n.rolling-text {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  white-space: nowrap;\r\n  color: white; /* add shadows to the text */\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  letter-spacing: 2px;\r\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\r\n  \r\n  /* Animação de rolagem */\r\n  animation: scrollText 120s linear infinite;\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .airport-panel-footer {\r\n    height: 12px;\r\n  }\r\n  .rolling-text {\r\n    font-size: 14px;\r\n  }\r\n}\r\n@media screen and (max-width: 480px) {\r\n  .airport-panel-footer {\r\n    height: 10%;\r\n  }\r\n  .rolling-text {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.rolling-text span {\r\n  margin-right: 100px;\r\n}\r\n\r\n@keyframes scrollText {\r\n  0% {\r\n    transform: translateY(-50%) translateX(90%);\r\n  }\r\n  100% {\r\n    transform: translateY(-50%) translateX(-90%);\r\n  }\r\n}\r\n\r\n.news-board-content-text {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n  color: rgb(255, 255, 255);\r\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n  font-weight: bold;\r\n  text-align: justify;\r\n  display: grid;\r\n  place-items: safe center;\r\n  font-size: 20px;\r\n  line-height: 1.25;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  overflow-wrap: anywhere;\r\n  overscroll-behavior: contain;\r\n  scrollbar-gutter: stable;\r\n  -webkit-overflow-scrolling: touch;\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\r\n  z-index: 1;\r\n  pointer-events: auto;\r\n  padding: 0px 5px;\r\n}\r\n\r\n.news-board-content-text-inner {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n@media screen and (max-width: 1024px) {\r\n  .news-board-content-text {\r\n    font-size: 14px;\r\n  }\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .news-board-content-text {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n/* Deve estar escrito sobre o  botão o texto \"FAKE\" */\r\n.button-container .button-fake::before {\r\n  content: 'Fake';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  color: blue;\r\n  font-family: 'Arial', sans-serif;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\r\n  margin: 0;\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .button-container .button-fake::before {\r\n    font-size: 10px;\r\n  }\r\n}\r\n@media screen and (max-width: 480px) {\r\n  .button-container .button-fake::before {\r\n    font-size: 8px;\r\n  }\r\n}\r\n\r\n.button-container .button-fake {\r\n  opacity: 1.0;\r\n  pointer-events: auto; \r\n  background-image: url('./assets/ui/botao-fake.png');\r\n  background-size: contain;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-color: transparent;\r\n  border: none;\r\n  margin-right: 10px;\r\n  margin-top: 0px;\r\n  will-change: transform, opacity;\r\n  transform: translateZ(0);\r\n  cursor: pointer !important;\r\n  transition: transform 0.3s ease;\r\n  transform: scale(1); \r\n  position: relative;\r\n  z-index: 3000;\r\n}\r\n\r\n.button-container .button-fake:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.button-container .button-not-fake::before {\r\n  content: 'Não Fake';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  color: blue;\r\n  font-family: 'Arial', sans-serif;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\r\n  margin: 0;\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .button-container .button-not-fake::before {\r\n    font-size: 10px;\r\n  }\r\n}\r\n@media screen and (max-width: 480px) {\r\n  .button-container .button-not-fake::before {\r\n    font-size: 8px;\r\n  }\r\n}\r\n\r\n.button-container .button-not-fake {\r\n  opacity: 1.0;\r\n  pointer-events: auto; \r\n  background-image: url('./assets/ui/botao-nao-fake.png');\r\n  background-size: contain;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n  background-color: transparent;\r\n  border: none;\r\n  margin-left: 10px;\r\n  margin-top: 0px;\r\n  will-change: transform, opacity;\r\n  transform: translateZ(0);\r\n  cursor: pointer !important;\r\n  transition: transform 0.3s ease;\r\n  transform: scale(1); \r\n  position: relative;\r\n  z-index: 3000;\r\n}\r\n\r\n.button-container .button-not-fake:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.model-selector {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  color: white;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  z-index: 5000;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.model-selector select {\r\n  background-color: #333;\r\n  color: white;\r\n  border: 1px solid #555;\r\n  border-radius: 4px;\r\n  padding: 4px 8px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  outline: none;\r\n}\r\n\r\n.model-selector select:hover {\r\n  background-color: #444;\r\n}\r\n\r\n.model-selector select:focus {\r\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n/* === PAINEL DE EXPLICAÇÃO === */\r\n.explanation-panel {\r\n  position: fixed;\r\n  top: 10%;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 60dvw; /* 50% da largura total da tela */\r\n  height: 60dvh; /* 50% da altura total da tela */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: auto;\r\n  will-change: transform, opacity;\r\n  transform: translateZ(0) translateX(-50%);\r\n}\r\n@media screen and (max-width: 1024px) {\r\n  .explanation-panel {\r\n    width: 95dvw;\r\n    height: 95dvh;\r\n  }\r\n}\r\n/*\r\n@media screen and (max-width: 768px) {\r\n  .explanation-panel {\r\n    width: 95dvw;\r\n    height: 95dvh;\r\n  }\r\n}\r\n*/\r\n\r\n/* \r\n  style={{ flex: 1, maxWidth: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}\r\n\r\n*/\r\n.explanation-panel-content {\r\n  flex: 1;\r\n  max-width: '80dvw';\r\n  display: 'flex';\r\n  flex-direction: 'column';\r\n  justify-content: 'space-between';\r\n}\r\n\r\n.explanation-panel-content-image {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  align-content: center;\r\n  position: relative;\r\n  width: auto;\r\n  height: auto;\r\n  margin: 0 50px;\r\n  z-index: 2001;\r\n  border-radius: 30px;\r\n  border: 5px solid rgba(255, 255, 255, 0.1);\r\n  pointer-events: auto;\r\n  opacity: 0.95;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Seções do conteúdo da explicação */\r\n.explanation-news-section {\r\n  padding: 5px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 12px;\r\n  border: 2px solid rgba(255, 255, 255, 0.8);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  backdrop-filter: blur(10px);\r\n  position: relative;\r\n  z-index: 10;\r\n  align-self: flex-start;\r\n  height: auto;\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .airport-panel-content  {\r\n    padding: 10px 3px;\r\n  }\r\n  .explanation-panel-content-image {\r\n    width: auto;\r\n    margin: 0 2px;\r\n  }\r\n  .explanation-news-section {\r\n    width: auto;\r\n    padding: 2px;\r\n    margin: 2px;\r\n  }\r\n  .explanation-news-section h3 {\r\n    font-size: 12px;\r\n  }\r\n  .explanation-news-section p {\r\n    font-size: 10px;\r\n  }\r\n  .explanation-text-section h3 {\r\n    font-size: 12px;\r\n  }\r\n  .explanation-text-section p {\r\n    font-size: 10px;\r\n  }\r\n  .airport-panel-footer{\r\n    top: auto;\r\n    bottom: 0px;\r\n    height: 6dvh;\r\n  }\r\n}\r\n@media screen and (max-width: 480px) {\r\n  .explanation-panel {\r\n    width: 100dvw;\r\n    height: fit-content;\r\n  }\r\n  .explanation-news-section {\r\n    width: auto;\r\n    padding: 1px;\r\n  }\r\n  .explanation-news-section h3 {\r\n    font-size: 10px;\r\n  }\r\n  .explanation-news-section p {\r\n    font-size: 8px;\r\n  }\r\n  .explanation-text-section {\r\n    width: auto;\r\n    padding: 1px;\r\n  }\r\n  .explanation-text-section h3 {\r\n    font-size: 10px;\r\n  }\r\n  .explanation-text-section p {\r\n    font-size: 8px;\r\n  }\r\n  .airport-panel-footer{\r\n    top: auto;\r\n    bottom: 0px;\r\n    height: 4dvh;\r\n  }\r\n}\r\n\r\n.explanation-news-section h3 {\r\n  margin: 0;\r\n  color: #2c3e50;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n}\r\n\r\n.explanation-news-section p {\r\n  margin: 5px;\r\n  color: #2c3e50;\r\n  line-height: 1.5;\r\n  text-align: justify;\r\n  font-weight: bold;\r\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n  font-size: 12px;\r\n  color:#6929fc;\r\n}\r\n\r\n/* === PAINEL DE STATUS DE ACERTOS === */\r\n.hits-status-panel {\r\n  position: fixed;\r\n  left: 20%;\r\n  bottom: 5%;\r\n  width: 280px;\r\n  height: auto;\r\n  z-index: 900;\r\n  border-radius: 15px;\r\n  border: 2px solid #bbb;\r\n  background: linear-gradient(to bottom, black, #040404); /* white degrades to light gray */\r\n  box-shadow: \r\n    0 4px 8px rgba(0, 0, 0, 0.3),\r\n    inset 0 2px 4px rgba(255, 255, 255, 0.3),\r\n    inset 0 -2px 4px rgba(0, 0, 0, 0.3);\r\n  padding: 12px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.hits-status-text {\r\n  color: white;\r\n  font-family: 'Arial', sans-serif;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\r\n  margin: 0;\r\n}\r\n\r\n.next-news-button {\r\n  position: fixed;\r\n  right: 6%;\r\n  bottom: 5%;\r\n  z-index: 1500;\r\n  padding: 12px 22px;\r\n  border-radius: 999px;\r\n  border: 2px solid #3d7d0a;\r\n  background: linear-gradient(180deg, #9be94a 0%, #5daf11 100%);\r\n  color: #0f2a00;\r\n  font-family: 'Arial', sans-serif;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.4);\r\n  cursor: pointer;\r\n  box-shadow:\r\n    0 3px 0 #3a6f0a,\r\n    0 10px 20px rgba(0, 0, 0, 0.35);\r\n  transform: translateZ(0);\r\n  transition: transform 0.1s ease, box-shadow 0.1s ease;\r\n}\r\n\r\n.next-news-button:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow:\r\n    0 7px 0 #3a6f0a,\r\n    0 12px 22px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.next-news-button:active {\r\n  transform: translateY(3px);\r\n  box-shadow:\r\n    0 3px 0 #3a6f0a,\r\n    0 6px 12px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n/* Desabilitado ao término da partida */\r\n.next-news-button:disabled {\r\n  cursor: not-allowed;\r\n  filter: grayscale(1);\r\n  opacity: 0.5;\r\n  transform: none;\r\n  box-shadow:\r\n    0 3px 0 #3a6f0a,\r\n    0 10px 20px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .hits-status-panel {\r\n    width: auto;\r\n    height: 20px;\r\n    padding: 10px 12px;\r\n    left: 5%;\r\n    bottom: 2%;\r\n  }\r\n  \r\n  .hits-status-text {\r\n    font-size: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .hits-status-panel {\r\n    width: auto;\r\n    height: 20px;\r\n    padding: 8px 10px;\r\n    left: 3%;\r\n    bottom: 1%;\r\n  }\r\n  \r\n  .hits-status-text {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n.explanation-text-section {\r\n  margin: 10px 0 10px 0;\r\n  padding: 5px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 12px;\r\n  border: 2px solid rgba(255, 255, 255, 0.8);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  backdrop-filter: blur(10px);\r\n  position: relative;\r\n  z-index: 10;\r\n  align-self: flex-end;\r\n  font-weight: bold;\r\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n  height: fit-content;\r\n}\r\n\r\n.explanation-text-section h3 {\r\n  margin: 0;\r\n  color: #2c3e50;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n}\r\n\r\n.explanation-text-section p {\r\n  margin: 5px;\r\n  color: #2c3e50;\r\n  font-size: 12px;\r\n  line-height: 1.6;\r\n  text-align: justify;\r\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Botões do painel de explicação */\r\n.explanation-buttons {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-top: 2px;\r\n  justify-content: center;\r\n}\r\n\r\n.explanation-button {\r\n  padding: 12px 24px;\r\n  border: none;\r\n  border-radius: 25px;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\r\n  min-width: 120px;\r\n  will-change: transform, opacity;\r\n  transform: translateZ(0);\r\n}\r\n@media screen and (max-width: 768px) {\r\n  .explanation-news-section p {\r\n    font-size: 10px;\r\n  }\r\n  .explanation-news-section h3 {\r\n    font-size: 12px;\r\n  }\r\n  .explanation-text-section p {\r\n    font-size: 10px;\r\n  }\r\n  .explanation-text-section h3 {\r\n    font-size: 12px;\r\n  }\r\n  .explanation-button {\r\n    font-size: 10px;\r\n    padding: 1px 2px;\r\n    min-width: 80px;\r\n  }\r\n  .explanation-buttons {\r\n    gap: 50%;\r\n    margin-top: 2px;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n.silence-button {\r\n  background: linear-gradient(145deg, var(--jedi-pink), #c0392b);\r\n  color: white;\r\n  border: 2px solid #a93226;\r\n}\r\n\r\n.silence-button:hover {\r\n  background: linear-gradient(145deg, #c0392b, #a93226);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(231, 76, 60, 0.4);\r\n}\r\n\r\n.close-button {\r\n  background: linear-gradient(145deg, var(--jedi-blue), #2980b9);\r\n  color: white;\r\n  border: 2px solid #2471a3;\r\n}\r\n\r\n.close-button:hover {\r\n  background: linear-gradient(145deg, #2980b9, #2471a3);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(52, 152, 219, 0.4);\r\n}\r\n\r\n.explanation-button:active {\r\n  transform: translateY(0);\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* Estilos para o carimbo FAKE */\r\n.fake-news-stamp {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  pointer-events: none;\r\n  /* Animação de zoom out - como se o carimbo descesse sobre a notícia */\r\n  animation: stampZoomOut 5s ease-out forwards;\r\n  z-index: 3000;\r\n}\r\n\r\n.fake-stamp-image {\r\n  width: 100px;\r\n  height: auto;\r\n  opacity: 0.9;\r\n  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.4));\r\n  transform: rotate(-15deg);\r\n}\r\n\r\n/* Animação do carimbo - efeito de zoom out */\r\n@keyframes stampZoomOut {\r\n  0% {\r\n    transform: translate(-50%, -50%) scale(10) rotate(-15deg);\r\n    opacity: 0;\r\n  }\r\n  20% {\r\n    transform: translate(-50%, -50%) scale(1.3) rotate(-15deg);\r\n    opacity: 0.8;\r\n  }\r\n  40% {\r\n    transform: translate(-50%, -50%) scale(0.9) rotate(-15deg);\r\n    opacity: 0.95;\r\n  }\r\n  60% {\r\n    transform: translate(-50%, -50%) scale(1.1) rotate(-15deg);\r\n    opacity: 0.9;\r\n  }\r\n  80% {\r\n    transform: translate(-50%, -50%) scale(0.95) rotate(-15deg);\r\n    opacity: 0.92;\r\n  }\r\n  100% {\r\n    transform: translate(-50%, -50%) scale(1) rotate(-15deg);\r\n    opacity: 0.9;\r\n  }\r\n}\r\n\r\n/* Estilo específico para o carimbo no painel de explicação */\r\n.fake-news-stamp.explanation-stamp {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 15;\r\n  pointer-events: none;\r\n  /* Animação de zoom out - como se o carimbo descesse sobre a notícia */\r\n  animation: stampZoomOut 12s ease-out forwards;\r\n}\r\n\r\n.explanation-stamp .fake-stamp-image {\r\n  width: 120px;\r\n  height: auto;\r\n  opacity: 0.85;\r\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));\r\n  transform: rotate(-20deg);\r\n}\r\n\r\n/* Variação para dispositivos móveis */\r\n@media (max-width: 768px) {\r\n  .fake-stamp-image {\r\n    width: 150px;\r\n  }\r\n  \r\n  .explanation-stamp .fake-stamp-image {\r\n    width: 90px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .fake-stamp-image {\r\n    width: 120px;\r\n  }\r\n  \r\n  .explanation-stamp .fake-stamp-image {\r\n    width: 80px;\r\n  }\r\n}\r\n\r\n/* === PAINEL DE VITÓRIA/CONCLUSÃO === */\r\n.victory-panel {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 65dvw;\r\n  height: 65dvh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  pointer-events: auto;\r\n  will-change: transform, opacity;\r\n  z-index: 1200;\r\n}\r\n\r\n.victory-panel-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 30px;\r\n  padding: 40px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\r\n  border: 5px solid rgba(255, 255, 255, 0.3);\r\n  animation: victorySlideIn 0.8s ease-out;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9001;\r\n}\r\n\r\n.victory-image-container {\r\n  margin-bottom: 20px;\r\n  animation: victoryImageBounce 1s ease-in-out infinite alternate;\r\n}\r\n\r\n.victory-image {\r\n  width: 300px;\r\n  height: auto;\r\n  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));\r\n}\r\n\r\n.victory-title {\r\n  font-size: 4rem;\r\n  font-weight: bold;\r\n  color: var(--jedi-violet);\r\n  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);\r\n  margin: 20px 0;\r\n  animation: victoryTitlePulse 1.5s ease-in-out infinite;\r\n}\r\n\r\n.restart-button {\r\n  margin-top: 30px;\r\n  padding: 20px 60px;\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, var(--jedi-green) 0%, var(--jedi-dark-green) 100%);\r\n  border: none;\r\n  border-radius: 50px;\r\n  cursor: pointer;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.restart-button:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.restart-button:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n/* Animações do painel de vitória */\r\n@keyframes victorySlideIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.5);\r\n  }\r\n  50% {\r\n    transform: scale(1.05);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes victoryImageBounce {\r\n  0% {\r\n    transform: translateY(0px);\r\n  }\r\n  100% {\r\n    transform: translateY(-10px);\r\n  }\r\n}\r\n\r\n@keyframes victoryTitlePulse {\r\n  0%, 100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n/* Responsividade do painel de vitória */\r\n@media screen and (max-width: 1024px) {\r\n  .victory-panel {\r\n    width: 90dvw;\r\n    height: 80dvh;\r\n  }\r\n  \r\n  .victory-image {\r\n    width: 200px;\r\n  }\r\n  \r\n  .victory-title {\r\n    font-size: 3rem;\r\n  }\r\n  \r\n  .restart-button {\r\n    padding: 15px 40px;\r\n    font-size: 1.4rem;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .victory-panel {\r\n    width: 95dvw;\r\n    height: 85dvh;\r\n  }\r\n  \r\n  .victory-image {\r\n    width: 150px;\r\n  }\r\n  \r\n  .victory-title {\r\n    font-size: 2.5rem;\r\n  }\r\n  \r\n  .restart-button {\r\n    padding: 12px 30px;\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n  .victory-panel {\r\n    width: 100dvw;\r\n    height: 90dvh;\r\n  }\r\n  \r\n  .victory-panel-content {\r\n    padding: 20px;\r\n  }\r\n  \r\n  .victory-image {\r\n    width: 120px;\r\n  }\r\n  \r\n  .victory-title {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .restart-button {\r\n    padding: 10px 25px;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n/* === RESPONSIVIDADE DO JOGO COMPLETO === */\r\n\r\n/* Container wrapper que preenche toda a viewport */\r\n.game-viewport-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: rgb(0, 0, 128);\r\n}\r\n\r\n/* Container escalável que se adapta à viewport */\r\n.game-responsive {\r\n  /* Será escalado via CSS custom properties (variáveis) */\r\n  transform: scale(var(--game-scale, 1));\r\n  transform-origin: center center;\r\n  /* Garantir que não cause overflow */\r\n  will-change: transform;\r\n}\r\n\r\n/* Cálculo de escala usando CSS clamp para diferentes viewports */\r\n:root {\r\n  /* Escala baseada na largura da viewport */\r\n  --scale-width: calc(100vw / 1920);\r\n  /* Escala baseada na altura da viewport */\r\n  --scale-height: calc(100vh / 1080);\r\n  /* Usar a menor escala para garantir que tudo caiba */\r\n  --game-scale: min(var(--scale-width), var(--scale-height));\r\n}\r\n\r\n/* Ajuste específico para modo retrato em dispositivos móveis */\r\n@media (max-width: 768px) and (orientation: portrait) {\r\n  :root {\r\n    --scale-width: calc(100vw / 1920);\r\n    --scale-height: calc(100vh / 1200); /* Ajuste para retrato */\r\n    --game-scale: min(var(--scale-width), var(--scale-height));\r\n  }\r\n  \r\n  .isometric-container {\r\n    padding: 10px; /* Margem de segurança */\r\n  }\r\n}\r\n\r\n/* Game Container e Viewport Classes */\r\n.game-viewport-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  background: #000;\r\n  z-index: 1;\r\n}\r\n\r\n.game-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: var(--jedi-violet);\r\n}\r\n\r\n.game-responsive {\r\n  transform-origin: center center;\r\n  transform: scale(var(--scale, 1));\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n/* Portrait Warning Overlay */\r\n.portrait-warning-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.75);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 10000;\r\n  color: var(--jedi-green);\r\n  text-align: center;\r\n  font-family: Arial, sans-serif;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.portrait-warning-text {\r\n  font-size: 3rem;\r\n  font-weight: bold;\r\n  margin-bottom: 2rem;\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.portrait-warning-subtitle {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 3rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.portrait-warning-icon {\r\n  font-size: 8rem;\r\n  margin-bottom: 2rem;\r\n  animation: rotate 5s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { opacity: 0.8; }\r\n  50% { opacity: 1; }\r\n}\r\n\r\n@keyframes rotate {\r\n  0% { transform: rotate(0deg); }\r\n  50% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* === BOTÃO DE TELA CHEIA === */\r\n.fullscreen-button {\r\n  position: fixed;\r\n  top: 20px;\r\n  left: 20px;\r\n  z-index: 10000;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 8px;\r\n  color: white;\r\n  cursor: pointer;\r\n  padding: 12px;\r\n  transition: all 0.3s ease;\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n}\r\n\r\n.fullscreen-button:hover {\r\n  background: rgba(0, 0, 0, 0.8);\r\n  border-color: rgba(255, 255, 255, 0.6);\r\n  transform: scale(1.05);\r\n}\r\n\r\n.fullscreen-button:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.fullscreen-button svg {\r\n  display: block;\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n/* Responsividade para dispositivos móveis */\r\n@media (max-width: 768px) {\r\n  .fullscreen-button {\r\n    top: 15px;\r\n    left: 15px;\r\n    padding: 10px;\r\n  }\r\n  \r\n  .fullscreen-button svg {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n/* === ESTADOS DE TELA CHEIA === */\r\n/* Quando em tela cheia, ajustar alguns elementos se necessário */\r\n:fullscreen .game-viewport-container,\r\n:-webkit-full-screen .game-viewport-container,\r\n:-moz-full-screen .game-viewport-container,\r\n:-ms-fullscreen .game-viewport-container {\r\n  /* Garantir que o container ocupe toda a tela disponível */\r\n  width: 100vw;\r\n  height: 100vh;\r\n}\r\n\r\n/* Esconder elementos desnecessários em tela cheia */\r\n:fullscreen .fullscreen-button,\r\n:-webkit-full-screen .fullscreen-button,\r\n:-moz-full-screen .fullscreen-button,\r\n:-ms-fullscreen .fullscreen-button {\r\n  /* Manter o botão visível mesmo em tela cheia */\r\n  position: fixed;\r\n  top: 20px;\r\n  right: 20px;\r\n  z-index: 10001;\r\n}\r\n\r\n/* Ajustes específicos para dispositivos móveis */\r\n@media (max-width: 768px) {\r\n  /* Ajustar z-index para melhor layering em mobile */\r\n  .game-info {\r\n    z-index: 200;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .debug-overlay {\r\n    z-index: 200;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .model-selector {\r\n    z-index: 5001;\r\n    font-size: 0.9rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .game-info {\r\n    padding: 10px;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .debug-overlay {\r\n    padding: 8px 12px;\r\n    font-size: 0.75rem;\r\n  }\r\n  \r\n  .model-selector {\r\n    font-size: 0.8rem;\r\n    padding: 6px 10px;\r\n  }\r\n}\r\n\r\n/* Ajustes para orientação landscape em dispositivos móveis */\r\n@media (max-height: 600px) and (orientation: landscape) {\r\n  .game-info {\r\n    top: 10px;\r\n    left: 10px;\r\n    padding: 8px 12px;\r\n    font-size: 0.75rem;\r\n  }\r\n  \r\n  .debug-overlay {\r\n    bottom: 10px;\r\n    left: 10px;\r\n    padding: 6px 10px;\r\n    font-size: 0.7rem;\r\n  }\r\n  \r\n  .model-selector {\r\n    top: 5px;\r\n    right: 5px;\r\n    padding: 4px 8px;\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n\r\n/* === SKATE MAGNÉTICO (flutua no lugar) === */\r\n.skate-container {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n/* Aura exagerada e bem visível */\r\n.skate-container.skate-active-effect::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 520px;\r\n  height: 260px;\r\n  background: radial-gradient(circle, rgba(0,180,255,0.9) 0%, rgba(0,150,255,0.6) 35%, rgba(0,100,255,0.3) 60%, transparent 85%);\r\n  filter: blur(90px) saturate(150%);\r\n  transform: translate(-50%, -50%) scale(1.1);\r\n  z-index: 0;\r\n  animation: glowPulse 2.0s ease-in-out infinite;\r\n}\r\n\r\n@keyframes glowPulse {\r\n  0%, 100% {\r\n    opacity: 0.8;\r\n    filter: blur(90px) saturate(150%);\r\n    transform: translate(-50%, -50%) scale(1.1);\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n    filter: blur(120px) saturate(200%);\r\n    transform: translate(-50%, -50%) scale(1.25);\r\n  }\r\n}\r\n\r\n.skate-container.skate-active-effect .skate-mag-image {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 320px;\r\n  height: auto;\r\n  display: block;\r\n  filter: drop-shadow(0 0 45px rgba(0, 100, 255, 0.9)) drop-shadow(0 0 90px rgba(0, 200, 255, 0.6));\r\n  animation: skateAura 2.0s ease-in-out infinite;\r\n}\r\n\r\n@keyframes skateAura {\r\n  0%, 100% {\r\n    filter: drop-shadow(0 0 15px rgba(0, 100, 255, 0.9)) drop-shadow(0 0 30px rgba(0, 0, 255, 0.6));\r\n    top: 0px;\r\n  }\r\n  50% {\r\n    filter: drop-shadow(0 0 30px rgba(0, 200, 255, 1)) drop-shadow(0 0 45px rgba(0, 100, 255, 0.9));\r\n    top: -3px;\r\n  }\r\n}\r\n\r\n/* === CONTAINER DO PORTAL DE DESMATERIALIZAÇÃO === */\r\n.portal-container {\r\n  position: absolute;\r\n  pointer-events: none;\r\n  width: 300px;\r\n  height: 300px;\r\n  scale: 1;\r\n}\r\n/* Aura exagerada e bem visível */\r\n.portal-container.portal-active-effect::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 520px;\r\n  height: 260px;\r\n  background: radial-gradient(circle, rgba(255,0,0,0.9) 0%, rgba(255,64,64,0.6) 35%, rgba(0,100,255,0.3) 60%, transparent 85%);\r\n  filter: blur(30px) saturate(50%);\r\n  transform: translate(-50%, -50%) scale(1.1);\r\n  z-index: 0;\r\n  animation: glowPulse 0.2s ease-in-out infinite;\r\n}\r\n\r\n.portal-container.portal-active-effect .portal-image {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 320px;\r\n  height: auto;\r\n  display: block;\r\n  filter: drop-shadow(0 0 15px rgba(255,63,63, 0.9)) drop-shadow(0 0 30px rgba(255,32,32, 0.6));\r\n  animation: portalAura 0.2s ease-in-out infinite;\r\n}\r\n\r\n@keyframes portalAura {\r\n  0%, 100% {\r\n    filter: drop-shadow(0 0 5px rgba(255,63,63, 0.9)) drop-shadow(0 0 10px rgba(255,32,32, 0.6));\r\n    top: 0px;\r\n  }\r\n  50% {\r\n    filter: drop-shadow(0 0 10px rgba(255,32,32, 1)) drop-shadow(0 0 15px rgba(255,63,63, 0.9));\r\n    top: -3px;\r\n  }\r\n}\r\n\r\n/* FIM DO PORTAL DE DESMATERIALIZAÇÃO */\r\n\r\n/* === EFEITO PULSANTE DAS PÍLULAS === */\r\n.pirula-container {\r\n  position: absolute;\r\n  pointer-events: none;\r\n}\r\n\r\n.pirula-container .pirula-image {\r\n  position: relative;\r\n  display: block;\r\n  z-index: 1;\r\n}\r\n\r\n.pirula-container.pirula-active-effect::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 160px;\r\n  height: 160px;\r\n  border-radius: 50%;\r\n  filter: blur(28px) saturate(140%);\r\n  transform: translate(-50%, -50%) scale(1);\r\n  z-index: 0;\r\n  animation: pillGlowPulse 0.5s ease-in-out infinite;\r\n}\r\n\r\n.pirula-container.pirula-active-effect .pirula-image {\r\n  animation: pillAura 1.8s ease-in-out infinite;\r\n}\r\n\r\n/* Cores por atributo data-pill-color */\r\n.pirula-container.pirula-active-effect[data-pill-color=\"vermelha\"]::before {\r\n  background: radial-gradient(circle, rgba(255,50,50,0.85) 0%, rgba(255,80,80,0.5) 40%, transparent 80%);\r\n}\r\n.pirula-container.pirula-active-effect[data-pill-color=\"vermelha\"] .pirula-image {\r\n  filter: drop-shadow(0 0 12px rgba(255,50,50,0.9)) drop-shadow(0 0 24px rgba(255,80,80,0.5));\r\n}\r\n\r\n.pirula-container.pirula-active-effect[data-pill-color=\"amarela\"]::before {\r\n  background: radial-gradient(circle, rgba(255,200,0,0.85) 0%, rgba(255,220,60,0.5) 40%, transparent 80%);\r\n}\r\n.pirula-container.pirula-active-effect[data-pill-color=\"amarela\"] .pirula-image {\r\n  filter: drop-shadow(0 0 12px rgba(255,200,0,0.9)) drop-shadow(0 0 24px rgba(255,220,60,0.5));\r\n}\r\n\r\n.pirula-container.pirula-active-effect[data-pill-color=\"azul\"]::before {\r\n  background: radial-gradient(circle, rgba(0,120,255,0.85) 0%, rgba(60,160,255,0.5) 40%, transparent 80%);\r\n}\r\n.pirula-container.pirula-active-effect[data-pill-color=\"azul\"] .pirula-image {\r\n  filter: drop-shadow(0 0 12px rgba(0,120,255,0.9)) drop-shadow(0 0 24px rgba(60,160,255,0.5));\r\n}\r\n\r\n.pirula-container.pirula-active-effect[data-pill-color=\"verde\"]::before {\r\n  background: radial-gradient(circle, rgba(0,200,80,0.85) 0%, rgba(60,220,120,0.5) 40%, transparent 80%);\r\n}\r\n.pirula-container.pirula-active-effect[data-pill-color=\"verde\"] .pirula-image {\r\n  filter: drop-shadow(0 0 12px rgba(0,200,80,0.9)) drop-shadow(0 0 24px rgba(60,220,120,0.5));\r\n}\r\n\r\n@keyframes pillGlowPulse {\r\n  0%, 100% {\r\n    opacity: 0.7;\r\n    transform: translate(-50%, -50%) scale(1);\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n    transform: translate(-50%, -50%) scale(2.4);\r\n  }\r\n}\r\n\r\n@keyframes pillAura {\r\n  0%, 100% {\r\n    top: 0px;\r\n  }\r\n  50% {\r\n    top: -3px;\r\n  }\r\n}\r\n/* FIM DO EFEITO PULSANTE DAS PÍLULAS */\r\n\r\n\r\n\r\n\r\nimg {\r\n  width: 320px;\r\n  height: auto;\r\n  display: block;\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  overflow: visible;\r\n}\r\n\r\n/* === TROFÉU FLUTUANTE (flutua no lugar) === */\r\n.ranking-image {\r\n  animation: objFloat 2.8s ease-in-out infinite;\r\n  will-change: transform;\r\n}\r\n\r\n@keyframes objFloat {\r\n  0%, 100% {\r\n    margin-top: 0px;\r\n  }\r\n  50% {\r\n    top: -16px;\r\n    margin-top: -8px;\r\n  }\r\n}\r\n\r\n/* === PORTAL DE DESMATERIALIZAÇÃO - ANIMAÇÕES === */\r\n\r\n/* Container do player com efeito de portal */\r\n.player.portal-dematerializing,\r\n.player.portal-rematerializing {\r\n  position: relative;\r\n}\r\n\r\n/* Pseudo-elemento para aura mágica atrás do player */\r\n.player.portal-dematerializing::before,\r\n.player.portal-rematerializing::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 200%;\r\n  height: 200%;\r\n  background: radial-gradient(circle, rgba(205, 143, 255, 0.75) 0%, rgba(95, 203, 255, 0.45) 45%, transparent 72%);\r\n  filter: blur(10px);\r\n  transform: translate(-50%, -50%) scale(0.35);\r\n  z-index: -1;\r\n  pointer-events: none;\r\n  opacity: 0;\r\n}\r\n\r\n/* Pseudo-elemento para partículas mágicas */\r\n.player.portal-dematerializing::after,\r\n.player.portal-rematerializing::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 200%;\r\n  height: 200%;\r\n  background:\r\n    radial-gradient(circle, rgba(255, 255, 255, 0.98) 0 8%, transparent 10%) 15% 78% / 34px 34px no-repeat,\r\n    radial-gradient(circle, rgba(199, 238, 255, 0.9) 0 10%, transparent 12%) 75% 70% / 40px 40px no-repeat,\r\n    radial-gradient(circle, rgba(196, 159, 255, 0.9) 0 9%, transparent 11%) 62% 86% / 30px 30px no-repeat,\r\n    radial-gradient(circle, rgba(150, 215, 255, 0.95) 0 8%, transparent 10%) 36% 62% / 26px 26px no-repeat,\r\n    radial-gradient(circle, rgba(255, 255, 255, 0.95) 0 8%, transparent 10%) 52% 82% / 24px 24px no-repeat;\r\n  mix-blend-mode: screen;\r\n  transform: translate(-50%, -50%) translateY(26px) scale(0.75);\r\n  z-index: 1;\r\n  pointer-events: none;\r\n  opacity: 0;\r\n}\r\n\r\n/* Animação de DESMATERIALIZAÇÃO (sprite desaparece) */\r\n.player.portal-dematerializing .player-sprite {\r\n  animation: portal-arcane-vanish 4s ease forwards;\r\n}\r\n\r\n.player.portal-dematerializing::before {\r\n  animation: portal-arcane-burst 4s ease forwards;\r\n}\r\n\r\n.player.portal-dematerializing::after {\r\n  animation: portal-sparkles-rise 4s ease forwards;\r\n}\r\n\r\n/* Animação de REMATERIALIZAÇÃO (sprite aparece) */\r\n/* NOTA: Usamos keyframes separados (portal-arcane-appear) em vez de 'reverse' \r\n   porque o browser não reinicia corretamente a animação quando o elemento \r\n   já está no estado final da animação anterior */\r\n.player.portal-rematerializing .player-sprite {\r\n  animation: portal-arcane-appear 4s ease forwards;\r\n}\r\n\r\n.player.portal-rematerializing::before {\r\n  animation: portal-arcane-burst-appear 4s ease forwards;\r\n}\r\n\r\n.player.portal-rematerializing::after {\r\n  animation: portal-sparkles-descend 4s ease forwards;\r\n}\r\n\r\n/* Keyframes - Efeito de desaparecimento mágico do sprite (DESMATERIALIZAÇÃO) */\r\n@keyframes portal-arcane-vanish {\r\n  0% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n    filter: drop-shadow(0 10px 25px rgba(0, 0, 0, 0.6)) brightness(1) saturate(1);\r\n  }\r\n  35% {\r\n    opacity: 1;\r\n    filter: drop-shadow(0 0 24px rgba(197, 140, 255, 0.9)) brightness(1.28) saturate(1.7);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: scale(0.86) translateY(-9px);\r\n    filter: blur(7px) brightness(1.9) saturate(2.1);\r\n  }\r\n}\r\n\r\n/* Keyframes - Efeito de aparecimento mágico do sprite (REMATERIALIZAÇÃO) */\r\n@keyframes portal-arcane-appear {\r\n  0% {\r\n    opacity: 0;\r\n    transform: scale(0.86) translateY(-9px);\r\n    filter: blur(7px) brightness(1.9) saturate(2.1);\r\n  }\r\n  65% {\r\n    opacity: 1;\r\n    filter: drop-shadow(0 0 24px rgba(197, 140, 255, 0.9)) brightness(1.28) saturate(1.7);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n    filter: drop-shadow(0 10px 25px rgba(0, 0, 0, 0.6)) brightness(1) saturate(1);\r\n  }\r\n}\r\n\r\n/* Keyframes - Explosão da aura mágica (DESMATERIALIZAÇÃO) */\r\n@keyframes portal-arcane-burst {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) scale(0.25);\r\n  }\r\n  25% {\r\n    opacity: 0.95;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) scale(1.35);\r\n  }\r\n}\r\n\r\n/* Keyframes - Contração da aura mágica (REMATERIALIZAÇÃO) */\r\n@keyframes portal-arcane-burst-appear {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) scale(1.35);\r\n  }\r\n  75% {\r\n    opacity: 0.95;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) scale(0.25);\r\n  }\r\n}\r\n\r\n/* Keyframes - Partículas mágicas subindo (DESMATERIALIZAÇÃO) */\r\n@keyframes portal-sparkles-rise {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) translateY(26px) scale(0.75);\r\n  }\r\n  30% {\r\n    opacity: 0.95;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) translateY(-30px) scale(1.15);\r\n  }\r\n}\r\n\r\n/* Keyframes - Partículas mágicas descendo (REMATERIALIZAÇÃO) */\r\n@keyframes portal-sparkles-descend {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) translateY(-30px) scale(1.15);\r\n  }\r\n  70% {\r\n    opacity: 0.95;\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) translateY(26px) scale(0.75);\r\n  }\r\n}\r\n\r\n/* === Help popup (usado no tabuleiro para desafios) === */\r\n.help-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  backdrop-filter: blur(3px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10010;\r\n}\r\n\r\n.help-card {\r\n  position: relative;\r\n  background: rgba(10, 10, 30, 0.92);\r\n  border: 1px solid rgba(196, 222, 29, 0.35);\r\n  border-radius: 16px;\r\n  width: min(800px, 92vw);\r\n  max-height: 90vh;\r\n  max-height: 90dvh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\r\n  animation: helpCardFadeIn 0.25s ease-out;\r\n  overflow-y: auto;\r\n}\r\n\r\n@keyframes helpCardFadeIn {\r\n  from { opacity: 0; transform: scale(0.95) translateY(10px); }\r\n  to   { opacity: 1; transform: scale(1) translateY(0); }\r\n}\r\n\r\n.help-card-close {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 12px;\r\n  background: none;\r\n  border: none;\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n}\r\n\r\n.help-card-close:hover {\r\n  color: #fff;\r\n}\r\n\r\n.help-card-title {\r\n  margin: 0;\r\n  padding: 18px 20px 10px;\r\n  font-size: 1.5rem;\r\n  color: var(--jedi-green, #c4de1d);\r\n  text-align: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.help-card-body {\r\n  padding: 4px 20px 20px;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.help-section {\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.help-section-title {\r\n  margin: 0 0 4px;\r\n  font-size: 1.3rem;\r\n  color: #fff;\r\n}\r\n\r\n.help-section-text {\r\n  margin: 0 0 6px;\r\n  font-size: 1.25rem;\r\n  line-height: 1.45;\r\n  color: rgba(255, 255, 255, 0.82);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
